import React from "react";
import { useOrderSSE } from "../hooks/useOrderSSE";

/**
 * Global notification handler component that maintains SSE connection
 * for new orders across all pages in the application.
 *
 * This component should be placed at the root level (App.tsx) to ensure
 * SSE connection works regardless of which page the user is on.
 * 
 * Note: Sound notifications are disabled here and only enabled on the Orders page.
 */
const GlobalNotificationHandler: React.FC = () => {
  // Setup SSE connection globally - sound is disabled, only Orders page plays sound
  const handleNewOrder = () => {
    // Individual pages can manage their own order state
  };

  useOrderSSE({
    onNewOrder: handleNewOrder,
    onOrderUpdate: () => {
      // Order updates handled by individual pages
    },
    playSound: false, // Sound disabled globally - only plays on Orders page
    openingTime: "08:00",
    closingTime: "22:00",
  });

  // This component doesn't render anything - it's just a hook wrapper
  return null;
};

export default GlobalNotificationHandler;
